import { ThemeObjectInterFace, ThemeV2 } from "../../util/types";
import { DeepPartial } from "../types";

const toStringOrUndefined = (value: unknown) =>
  typeof value === "string" && value.trim().length > 0 ? value : undefined;

const toBooleanOrUndefined = (value: unknown) =>
  typeof value === "boolean" ? value : undefined;

const toStringArrayOrUndefined = (value: unknown): string[] | undefined =>
  Array.isArray(value) && value.every((item) => typeof item === "string")
    ? value
    : undefined;

export const mapV1ToV2 = (
  v1: Partial<ThemeObjectInterFace>,
): DeepPartial<ThemeV2> => ({
  tokens: {
    color: {
      action: {
        primary: toStringOrUndefined(v1.main_color),
      },
      text: {
        primary: toStringOrUndefined(v1.text_color),
        accent:
          toStringOrUndefined(v1.accent_color) ??
          toStringOrUndefined(v1.main_color),
      },
      surface: {
        card: toStringOrUndefined(v1.secondary_color),
      },
      feedback: {
        error: toStringOrUndefined(v1.error_color),
      },
    },
  },
  assets: {
    header: { icon: toStringOrUndefined(v1.icon_image) },
    chat: { background: toStringOrUndefined(v1.background_image) },
  },
  copy: {
    status: { transitions: toStringArrayOrUndefined(v1.transition_messages) },
    header: {
      line1: toStringOrUndefined(v1.line_1),
      line2: toStringOrUndefined(v1.line_2),
    },
    redirect: toStringOrUndefined(v1.redirect_message),
    close: toStringOrUndefined(v1.close_message),
    disqualification: toStringOrUndefined(v1.disqualification_message),
    hints: {
      waiting: toStringOrUndefined(v1.hints?.waiting),
      multichoice: toStringOrUndefined(v1.hints?.multichoice),
      multiselect: toStringOrUndefined(v1.hints?.multiselect),
      others: toStringOrUndefined(v1.hints?.others),
      multitext: toStringOrUndefined(v1.hints?.multitext),
    },
    actions: {
      send: toStringOrUndefined(v1.send_button),
    },
  },
  layout: {
    orientation: toStringOrUndefined(v1.orientation),
  },
  show_progress: toBooleanOrUndefined(v1.show_progress),
  show_grid_lines: toBooleanOrUndefined(v1.show_grid_lines),
  transition_messages: toStringArrayOrUndefined(v1.transition_messages),
});
